import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IReportEmbedConfiguration, models } from "powerbi-client";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class ReportService {
  private dlReportId = "d4c55368546b76ab36a4";
  private plannerReportId = "d1e7e3e43c65b9a087b4";
  private realCostReportId = "015d8920-6ccd-4079-bd34-25ed1eb4dad4";

  private readonly endpoint = environment.apiUrl;

  constructor(private http: HttpClient) {}

  setupReportConfiguration(
    page: string,
    accessToken: string,
  ): IReportEmbedConfiguration {
    const reportConfiguration = {
      type: "report",
      id: "52d38266-2088-461d-8561-86d3e09542f1",
      embedUrl: `https://app.powerbi.com/reportEmbed?reportId=52d38266-2088-461d-8561-86d3e09542f1&ctid=76e3e3ff-fce0-45ec-a946-bc44d69a9b7e`,
      // DEVL
      // id: "3cde6960-1e5f-4b9b-94a5-0cf12280c518",
      // embedUrl: `https://app.powerbi.com/reportEmbed?reportId=3cde6960-1e5f-4b9b-94a5-0cf12280c518&ctid=76e3e3ff-fce0-45ec-a946-bc44d69a9b7e`,
      accessToken: accessToken || undefined,
      tokenType: models.TokenType.Aad,
      pageName: page,
      settings: {
        panes: {
          filters: {
            expanded: false,
            visible: false,
          },
          pageNavigation: {
            visible: false,
          },
        },
        localeSettings: {
          language: "en-us",
        },
        customLayout: {
          reportAlignment: models.ReportAlignment.Center,
          displayOption: models.DisplayOption.FitToWidth,
        },
        bookmarksPaneEnabled: false,
        filterPaneEnabled: false,
      },
    };
    return reportConfiguration;
  }

  getPlannerReportId() {
    return this.plannerReportId;
  }
  getDlReportId() {
    return this.dlReportId;
  }

  getAgIdAndLevelByCode(code: string) {
    return this.http.get<{
      agreementInfo: { agreementId: number; level: number };
    }>(`${this.endpoint}/sm/agreementInfo`, { params: { code } });
  }

  getRealCostReportId() {
    return this.realCostReportId;
  }

  /**
   * Builds the embed URL for the Real Cost paginated report (iframe approach)
   * @param contractId - The contract ID to pass as a report parameter
   * @returns The complete embed URL for the paginated report
   */
  getRealCostReportEmbedUrl(contractId: number, billingEventId: number | null): string {
    const tenantId = "76e3e3ff-fce0-45ec-a946-bc44d69a9b7e";
    return `https://app.powerbi.com/rdlEmbed?reportId=${this.realCostReportId}&autoAuth=true&ctid=${tenantId}&rp:ContractID=${contractId}&rp:BillingEventID=${billingEventId ?? ''}`;
  }

  /**
   * Sets up configuration for the Real Cost paginated report using PowerBI SDK
   * @param contractId - The contract ID to pass as a report parameter
   * @param accessToken - The access token from Master User authentication
   * @returns The report embed configuration
   */
  setupRealCostReportConfiguration(
    contractId: number,
    billingEventId: number | null,
    accessToken: string,
  ): models.IPaginatedReportLoadConfiguration {
    const reportConfiguration: models.IPaginatedReportLoadConfiguration = {
      type: "report",
      id: '015d8920-6ccd-4079-bd34-25ed1eb4dad4',
      embedUrl: 'https://app.powerbi.com/rdlEmbed?reportId=015d8920-6ccd-4079-bd34-25ed1eb4dad4',
      accessToken: accessToken,
      tokenType: models.TokenType.Aad,
      parameterValues: [
        { name: 'ContractID', value: contractId.toString() },
        { name: 'BillingEventID', value: billingEventId?.toString() ?? '' }
      ],
      settings: {
        commands: {
          parameterPanel: {
              enabled: false,
              expanded: false
          }
        }
      }
    };
    return reportConfiguration;
  }
}
